import { useAppSelector } from '../useAppSelector/useAppSelector'

export const useAuth = () => {
    const authData = useAppSelector((state) => state.authUser.authUser)

    return { authUser: authData }
}
